<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :top="TopBarY" />
    <van-tabs v-model="activeManage" :color="GetDiveMainBack()" :border="false">
      <van-tab title="概述" name="base">
        <van-skeleton title :row="10" :loading="loading">
          <template v-if="data">
            <van-steps :active="data.classStateId" :active-color="GetDiveMainBack()">
              <van-step>待开始</van-step>
              <van-step>即将开始</van-step>
              <van-step>进行中</van-step>
              <van-step>行程结束</van-step>
            </van-steps>
            <div class="baseRect">
              <van-row gutter="10" class="values">
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">潜店: </span>{{ data.diveStoreName }}</van-col>
                <van-col v-if="data.course" span="12"><span :style="'color:'+GetDiveMainBack()">课程: </span>{{ data.course.name }}</van-col>
              </van-row>
              <van-row gutter="10" class="values">
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">队名: </span>{{ data.team.className }}</van-col>
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">状态: </span>{{ GetEnumText('Em_ClassState',data.team.state) }}</van-col>
              </van-row>
              <van-row gutter="10" class="values">
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">创建时间: </span>{{ formatDate(data.team.dateCreate,"yyyy/MM/dd hh:mm",true) }}</van-col>
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">队员人数: </span>{{ data.team.memberNum }}</van-col>
              </van-row>
              <van-row gutter="10" class="values">
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">开始时间: </span>{{ data.team.dateStart?formatDate(data.team.dateStart,"yyyy/MM/dd",true):'-' }}</van-col>
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">结束时间: </span>{{ data.team.dateFinish?formatDate(data.team.dateFinish,"yyyy/MM/dd",true):'-' }}</van-col>
              </van-row>
              <van-row gutter="10" class="values">
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">主教练: </span>{{ data.coachName }}</van-col>
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()" /></van-col>

              </van-row>
            </div>
            <div v-if="data && data.course" class="baseRect">
              <div class="topTitle">{{ data.course.tripType==='Course'?'课程信息':'行程信息' }}<span :style="'color:'+GetDiveMainBack()">{{ data.course.tripType==='Course'?'COURSE':'TRAVEL' }}</span></div>
              <van-row gutter="10" class="values">
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">组织: </span>{{ GetEnumText('Em_CertificationGroupType',data.course.groupTeam) }}</van-col>
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">分类: </span>{{ data.course.typeName }}</van-col>
              </van-row>
              <van-row gutter="10" class="values">
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">时长: </span>{{ data.course.defaultDate }} 天</van-col>
                <van-col span="12"><span :style="'color:'+GetDiveMainBack()">简称: </span>{{ data.course.nameShort }}</van-col>
              </van-row>
              <van-row class="values">
                <van-col span="24"><span :style="'color:'+GetDiveMainBack()">备注: </span>{{ data.course.remark }}</van-col>
              </van-row>
              <van-row class="values">
                <van-col span="24"><span :style="'color:'+GetDiveMainBack()">操作: </span>
                  <van-button
                    style="min-width: 7em;"
                    type="primary"
                    :color="GetDiveMainBack()"
                    size="mini"
                    plain
                    hairline
                    @click="onShareClass"
                  >邀请全队评分</van-button>
                </van-col>
              </van-row>
            </div>

            <div v-if="data && data.course" class="baseRect">
              <div class="topTitle">{{ data.course.tripType==='Course'?'课程单元':'项目详情' }}<span :style="'color:'+GetDiveMainBack()">{{ data.course.tripType==='Course'?'UNIT':'PROJECT' }}</span></div>
              <table class="tableRect" cellspacing="0">
                <tr class="title" :style="'color:'+GetDiveMainBack()">
                  <td>名称</td>
                  <td>类型</td>
                  <td>占比</td>
                  <td>佣金</td>
                </tr>
                <tr v-for="unit in data.unitList" :key="unit.diveCourseUnitId">
                  <td>{{ unit.unitName }}</td>
                  <td>{{ GetEnumText('Em_CourseUnitType',unit.type) }}</td>
                  <td>{{ ShowFloat(unit.proprotionMilli*0.1) }}%</td>
                  <td v-if="unit.commissionCurrency">{{ unit.commissionCurrency }} {{ ShowMoney(unit.commissionTotalPrice) }}</td>
                  <td v-if="!unit.commissionCurrency">N/A</td>
                </tr>
              </table>
            </div>
            <!-- <div class="baseRect">
          <div class="topTitle">管理<span :style="'color:'+GetDiveMainBack()">MANAGE</span></div>

        </div> -->
          </template>
        </van-skeleton>
      </van-tab>
      <van-tab title="顾客" name="member">
        <van-tabs v-if="data" v-model="activeMember" scrollspy sticky :color="GetDiveMainBack()" @scroll="onMemberScroll">
          <van-tab v-for="member in data.memberList" :key="member.student.studentId" :title="member.student.lastName+' '+member.student.firstName">
            <div class="baseRect memberRect">
              <div class="HeadRect">
                <div class="head">
                  <van-image
                    width="5em"
                    height="6.5em"
                    fit="cover"
                    radius="0.4em"
                    lazy-load
                    :src="member.student.icon?member.student.icon:'/img/defaultUserIcon.jpg'"
                  />
                </div>
                <div class="valueRect">
                  <van-row gutter="10" class="values breakAll">
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">姓名: </span>{{ member.student.loaclName }}</van-col>
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">状态: </span><b>{{ GetEnumText('Em_LearningState',member.student.state) }}</b>
                      <van-button
                        v-if="member.student.state === 'Wait' || member.student.state === 'OnTheoretical' || member.student.state === 'FinishTheoretical'|| member.student.state === 'OnCourse'"
                        style="min-width: 30px;margin-left:0.5em"
                        type="danger"
                        size="mini"
                        plain
                        hairline
                        @click="onStopStudent(member.student)"
                      >终止行程</van-button>
                      <template v-if="member.student.cancelState !=='None'">
                        <van-tag v-if="member.student.cancelState !=='Cancel'" type="danger">
                          {{ GetEnumText('Em_StudentCancelState',member.student.cancelState) }}
                        </van-tag>
                        <van-button
                          v-if="member.student.cancelState ==='Cancel'"
                          style="min-width: 30px;margin-left:0.5em"
                          type="danger"
                          size="mini"
                          plain
                          hairline
                          :loading="buttonLoading"
                          @click="onReStopStudent(member.student)"
                        >{{ GetEnumText('Em_StudentCancelState',member.student.cancelState) }}</van-button>
                        <van-count-down v-if="member.student.cancelState ==='WaitCheck' && member.student.cancelFinishTimeMSecond>0" style="display: inline;" :time="member.student.cancelFinishTimeMSecond" />
                      </template>
                    </van-col>
                  </van-row>
                  <van-row gutter="10" class="values breakAll">
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">姓: </span>{{ member.student.lastName }}</van-col>
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">名: </span>{{ member.student.firstName }} </van-col>
                  </van-row>
                  <van-row gutter="10" class="values">
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">性别: </span>{{ member.student.sex }}</van-col>
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">生日: </span>{{ member.student.birthday?formatDate(member.student.birthday,'yyyy/MM/dd'):'-' }}</van-col>
                  </van-row>
                  <van-row gutter="10" class="values  breakAll">
                    <van-col
                      v-clipboard:success="onCopySocialMediaAccount"
                      v-clipboard:copy="copyStr"
                      span="12"
                      @click="copyStr=undefined;copyStr= member.student.email;"
                    >
                      <span :style="'color:'+GetDiveMainBack()">邮箱: </span>{{ member.student.email }}</van-col>
                    <van-col
                      v-clipboard:success="onCopySocialMediaAccount"
                      v-clipboard:copy="copyStr"
                      span="12"
                      @click="copyStr=undefined;copyStr= member.student.phone;"
                    >
                      <span :style="'color:'+GetDiveMainBack()">电话: </span>{{ member.student.phoneCountry }} {{ member.student.phone }}</van-col>
                  </van-row>
                  <van-row gutter="10" class="values">
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">身高: </span>{{ member.student.height }}</van-col>
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">鞋码: </span>{{ member.student.shoeSize }}</van-col>
                  </van-row>
                  <van-row gutter="10" class="values">
                    <van-col span="12"><span :style="'color:'+GetDiveMainBack()">体重: </span>{{ member.student.weight }}</van-col>
                    <van-col span="12" />
                  </van-row>
                </div>
                <div class="values">  <span :style="'color:'+GetDiveMainBack()">地址: </span>
                  {{ member.student.country }}
                  {{ member.student.cityEng }}
                  {{ member.student.area }}
                  {{ member.student.address }}
                  ({{ member.student.postalCode }})
                </div>
                <div
                  v-clipboard:success="onCopySocialMediaAccount"
                  v-clipboard:copy="copyStr"
                  class="values"
                  @click="copyStr=undefined;copyStr= member.student.socialMediaAccount;"
                >
                  <span :style="'color:'+GetDiveMainBack()">社交媒体账号: </span>
                  {{ member.student.socialMediaAccount }}
                </div>
                <div
                  v-if="member.diveOrder.bookSocialMediaAccount"
                  v-clipboard:success="onCopySocialMediaAccount"
                  v-clipboard:copy="copyStr"
                  class="values"
                  @click="copyStr=undefined;copyStr= member.diveOrder.bookSocialMediaAccount;"
                >
                  <span :style="'color:'+GetDiveMainBack()">预订人社交媒体账号: </span>
                  {{ member.diveOrder.bookSocialMediaAccount }}
                </div>

                <div class="values">  <span :style="'color:'+GetDiveMainBack()">备注: </span>
                  {{ member.student.reamrk }}
                </div>
                <div class="values">  <span :style="'color:'+GetDiveMainBack()">私密备注: </span>
                  {{ member.student.remarkPrivate }}
                </div>

                <div
                  v-clipboard:success="onCopySocialMediaAccount"
                  v-clipboard:copy="copyStr"
                  class="values"
                  @click="copyStr=undefined;copyStr= member.student.bindHashCode;"
                >  <span :style="'color:'+GetDiveMainBack()">绑定信息(点击复制): </span>
                  <van-tag v-if="!member.userId" type="danger" size="mini" plain hairline>未绑定用户</van-tag>
                  <van-tag v-else :color="GetDiveMainBack()">已绑定用户</van-tag>&nbsp;
                  <van-tag v-if="!member.headIcon || !member.address" type="danger" size="mini" plain hairline>未完善信息</van-tag>
                  <van-tag v-else :color="GetDiveMainBack()">已完善信息</van-tag>
                </div>

                <template v-if="!member.diveOrder">
                  <div class="values">  <span :style="'color:'+GetDiveMainBack()">行程订单: </span>
                    不存在,请联系客服
                  </div>
                </template>
                <template v-if="member.diveOrder">
                  <div class="values">  <span :style="'color:'+GetDiveMainBack()">订单费用: </span>
                    已付款 <b>CNY {{ ShowMoney(member.diveOrder.payPrice) }}</b> / 总费用 <b>CNY {{ ShowMoney(member.diveOrder.totalPrice) }}</b>
                  </div>

                  <div class="values">  <span :style="'color:'+GetDiveMainBack()">款项: </span>
                    <van-tag v-if="0.01 > Math.abs(member.diveOrder.totalPrice - member.diveOrder.payPrice)" :color="GetDiveMainBack()">已结清</van-tag>
                    <van-tag v-if="member.diveOrder.totalPrice < member.diveOrder.payPrice" :color="GetDiveMainBack()">已结清 多支付CNY {{ ShowMoney(member.diveOrder.payPrice - member.diveOrder.totalPrice) }}</van-tag>
                    <van-tag v-if="member.diveOrder.totalPrice > member.diveOrder.payPrice" type="warning">CNY {{ ShowMoney(member.diveOrder.totalPrice - member.diveOrder.payPrice) }} 未结清</van-tag>

                    <van-button
                      style="min-width: 7em;margin-left:1em;"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      @click="onShowDiveOrderInfo(member.diveOrder.diveOrderId)"
                    >
                      查看行程订单
                    </van-button>

                  </div>

                  <!-- <div class="values">  <span :style="'color:'+GetDiveMainBack()">预订人: </span>
                    {{member.diveOrder.bookName}}
                  </div> -->
                </template>
                <template v-if="GetIsEnableInsurance()">
                  <div class="values">
                    <span :style="'color:'+GetDiveMainBack()">保险: </span>
                    <span v-if="member.student.insuranceImage && !member.student.insuranceOrderId">图片保单</span>
                    <span v-if="member.student.insuranceOrderId">电子保单</span>
                    <span v-if="!member.student.insuranceImage && !member.student.insuranceOrderId">尚未提交</span>
                  </div>
                  <div v-if="member.student.insuranceImage" class="values">
                    <span :style="'color:'+GetDiveMainBack()">保单截图: </span>
                    <van-button
                      style="min-width: 7em;margin-left:1em;"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      @click="onImagePreview(member.student.insuranceImage)"
                    >
                      查看保单截图
                    </van-button>
                  </div>
                  <template v-if="member.insurance && member.insurance.order">
                    <div class="values">  <span :style="'color:'+GetDiveMainBack()">保险: </span>
                      {{ member.insurance.order.productName }}
                    </div>
                    <div class="values">  <span :style="'color:'+GetDiveMainBack()">保障期限: </span>
                      {{ member.insurance.orderInfo.deadlineText }}
                    </div>
                    <div class="values">  <span :style="'color:'+GetDiveMainBack()">保单号: </span>
                      {{ member.insurance.order.insureNum }}
                    </div>
                    <div class="values">  <span :style="'color:'+GetDiveMainBack()">保障日期: </span>
                      {{ member.insurance.orderInfo.deadline }}
                    </div>
                    <div class="values">  <span :style="'color:'+GetDiveMainBack()">保单出单状态: </span>
                      {{ GetEnumText('Em_IssueStatus',member.insurance.order.issueStatus) }}
                    </div>
                    <div class="values">  <span :style="'color:'+GetDiveMainBack()">保单生效状态: </span>
                      {{ GetEnumText('Em_EffectiveStatus',member.insurance.order.effectiveStatus) }}
                    </div>
                  </template>
                </template>
              </div>

              <table class="tableRect" cellspacing="0">
                <tr class="title" :style="'color:'+GetDiveMainBack()">
                  <td>名称</td>
                  <td>完成情况</td>
                  <td>教练</td>
                  <td>时间</td>
                  <td>操作</td>
                </tr>
                <tr v-for="unit in data.unitList" :key="unit.diveCourseUnitId">
                  <td>{{ unit.unitName }}</td>
                  <template v-if="getStudentProgress(member.progressList,unit.diveCourseUnitId)">
                    <td v-if="getStudentProgress(member.progressList,unit.diveCourseUnitId).state!=='FINISH'">
                      {{ GetEnumText("Em_DiveUnitState",getStudentProgress(member.progressList,unit.diveCourseUnitId).state) }}
                    </td>
                    <td v-if="getStudentProgress(member.progressList,unit.diveCourseUnitId).state==='FINISH'">
                      {{ GetEnumText("Em_CompletionState",getStudentProgress(member.progressList,unit.diveCourseUnitId).completionState) }}
                    </td>
                    <td>{{ getStudentProgress(member.progressList,unit.diveCourseUnitId).coachName }}</td>
                    <td>{{ formatDate(getStudentProgress(member.progressList,unit.diveCourseUnitId).lastTime,"MM/dd hh:mm",true) }}</td>
                  </template>
                  <template v-else>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>

                  </template>
                  <td class="center">
                    <van-button
                      style="min-width: 3em;"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      @click="onShowProgressEdit(member,unit,getStudentProgress(member.progressList,unit.diveCourseUnitId))"
                    >
                      {{ member.student.state !== 'Wait' &&member.student.state !== 'OnTheoretical' &&member.student.state !== 'FinishTheoretical' &&member.student.state !== 'OnCourse'?'查看':'操作' }}
                    </van-button>
                  </td>
                </tr>
                <tr v-if="data.course&& data.course.tripType ==='SCHEDULING'">
                  <td v-if="checkAllUnitFinish(member)"><b>完成行程</b></td>
                  <td v-else>完成行程</td>
                  <td v-if="member.student.state ==='Certificate'||member.student.state ==='Success'">
                    <b>已完成</b>
                  </td>
                  <td v-else>-</td>
                  <td>{{ member.student.picVerifyCoachName }}</td>
                  <td>-</td>
                  <td class="center">
                    <van-button
                      style="min-width: 30px;"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      :loading="buttonLoading"
                      :disabled="!checkAllUnitFinish(member)"
                      @click="onFinishScheduling(member)"
                    >完成</van-button>
                  </td>
                </tr>
                <tr v-if="data.course && data.course.tripType ==='COURSE'">
                  <td v-if="checkAllUnitFinish(member)"><b>签发证书</b></td>
                  <td v-else>签发证书</td>
                  <td v-if="member.student.state ==='Finished'||member.student.state ==='Certificateing'">
                    认证中
                  </td>
                  <td v-else-if="member.student.state ==='Certificate'||member.student.state ==='Success'">
                    <b>认证成功</b>
                  </td>
                  <td v-else>-</td>
                  <td>{{ member.student.picVerifyCoachName }}</td>
                  <td>-</td>
                  <td class="center">
                    <van-button
                      style="min-width: 3em;"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      :disabled="!checkAllUnitFinish(member)"
                      @click="onVerifyCertificate(member)"
                    >提交</van-button>
                  </td>
                </tr>
                <tr v-if="member.student.state==='Certificate' && !member.commentTripId">
                  <td>邀请评分</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td class="center">
                    <van-button
                      style="min-width: 3em"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      @click="onShareComment(member.student)"
                    >邀请</van-button>
                  </td>
                </tr>
                <tr v-if="member.commentTripId">
                  <td>行程评分</td>
                  <td>{{ ShowMoney(member.commentTripScore) }}分</td>
                  <td>-</td>
                  <td>{{ formatDate(member.commentTripDate,"MM/dd hh:mm",true) }}</td>
                  <td class="center">
                    <van-button
                      style="min-width: 3em;"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      @click="onViewComment('Course',member.commentTripId)"
                    >详情</van-button>
                  </td>
                </tr>
                <tr v-if="member.commentCoachId">
                  <td>教练评分</td>
                  <td><b>{{ ShowMoney(member.commentCoachScore) }}分</b></td>
                  <td>-</td>
                  <td>{{ formatDate(member.commentCoachDate,"MM/dd hh:mm",true) }}</td>
                  <td class="center">
                    <van-button
                      style="min-width: 3em;"
                      type="primary"
                      :color="GetDiveMainBack()"
                      size="mini"
                      plain
                      hairline
                      @click="onViewComment('Coach',member.commentCoachId)"
                    >详情</van-button></td>
                </tr>
              </table>

              <table class="tableRect" cellspacing="0" style="margin-top:1em;">
                <tr class="title" :style="'color:'+GetDiveMainBack()">
                  <td>装备</td>
                  <td>租期</td>
                  <td>规格</td>
                </tr>
                <template v-if="member.equipmentLease && member.equipmentLease.length>0">
                  <tr v-for="equips in member.equipmentLease" :key="equips.equipmentLeaseId">
                    <td>
                      <van-tag v-if="equips.isLock" :color="GetDiveMainBack()">已锁定</van-tag>
                      {{ equips.equipmentLeaseId==='0'?'无需租赁':equips.title }}</td>
                    <td><b>{{ equips.count }}</b> {{ equips.priceUnit }}</td>
                    <td>{{ equips.specifications }}</td>
                  </tr>
                </template>
              </table>

              <div v-if="member" class="LogInfo">
                <div v-for="log in member.logList" :key="log.studentLogId" class="LogRect">
                  <van-tag mark :color="GetDiveMainBack()">  {{ GetEnumText("Em_DiveStudentLogType",log.type ) }}</van-tag>
                  <span class="data">{{ log.body }}</span>
                  <span class="date">{{ formatDate(log.createTime,"yyyy-MM-dd hh:mm",true) }}</span>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>

      </van-tab>
      <van-tab title="进度" name="progress">
        <div v-if="data" class="progressRect">
          <table class="tableRect" cellspacing="0">
            <tr class="title" :style="'color:'+GetDiveMainBack()">
              <td style="width:3em;">选择</td>
              <td>学员</td>
              <td v-for="unit in data.unitList" :key="unit.diveCourseUnitId">{{ unit.unitName }}</td>
            </tr>
            <tr class="title" :style="'color:'+GetDiveMainBack()">

              <td><span @click="toggleAll(data.memberList,true)">全</span>
                &nbsp;
                <span @click="toggleAll(data.memberList)">反</span></td>
              <td><span @click="toggleAll(data.unitList,true)">全选</span>
                 &nbsp;
                <span @click="toggleAll(data.unitList)">反选</span></td>
              <td v-for="(unit,index) in data.unitList" :key="unit.diveCourseUnitId">
                <van-checkbox v-model="data.unitList[index].select" shape="square" :checked-color="GetDiveMainBack()" />
              </td>
            </tr>

            <tr v-for="(member,index) in data.memberList" :key="member.student.studentId">
              <td>
                <van-checkbox
                  v-model="data.memberList[index].select"
                  :disabled="member.student.state!=='Wait' && member.student.state!=='OnTheoretical' && member.student.state!=='FinishTheoretical' && member.student.state!=='OnCourse'"
                  :checked-color="GetDiveMainBack()"
                /></td>
              <td>{{ member.student.firstName }}</td>
              <td
                v-for="unit in data.unitList"
                :key="unit.diveCourseUnitId"
                class="rect"
                :style="'background-color:'+getUnitStateColor(member,unit.diveCourseUnitId)"
                @click="onSelectProgress(member,unit,getStudentProgress(member.progressList,unit.diveCourseUnitId))"
              >
                {{ getUnitStateText(member,unit.diveCourseUnitId) }}
              </td>
            </tr>
            <tr>
              <td colspan="100" style="color:#999">
                图例: <van-tag color="#ccc">/</van-tag>未开始
                <van-tag color="#ee0a24">x</van-tag>取消
                <van-tag color="#ff976a">!</van-tag>未完成
                <van-tag color="#0FF77D">1</van-tag>不理想
                <van-tag color="#07c160">2</van-tag>待提高
                <van-tag color="#059C4D">3</van-tag>良好
                <van-tag color="#035A2D">4</van-tag>极好
              </td>
            </tr>
          </table>
        </div>
        <div class="baseRect">
          <div class="topTitle">管理<span :style="'color:'+GetDiveMainBack()">MANAGE</span></div>
          <van-row gutter="10" class="values">
            <van-col span="5"><span :style="'color:'+GetDiveMainBack()">状态</span></van-col>
            <van-col span="19">
              <van-radio-group v-model="progressForm.state" direction="horizontal" :checked-color="GetDiveMainBack()">
                <van-radio v-for="item in progressStateList" :key="item.value" class="radioItem" :name="item.value">{{ item.text }}</van-radio>
              </van-radio-group>
            </van-col>
          </van-row>
          <van-row v-if="progressForm.state==='FINISH'" gutter="10" class="values">
            <van-col span="5"><span :style="'color:'+GetDiveMainBack()">完成质量</span></van-col>
            <van-col span="19">
              <van-radio-group v-model="progressForm.completionState" direction="horizontal" :checked-color="GetDiveMainBack()">
                <van-radio v-for="item in progressCompletionList" :key="item.value" class="radioItem" :name="item.value">{{ item.text }}</van-radio>
              </van-radio-group>
            </van-col>
          </van-row>
          <van-row gutter="10" class="values">
            <van-col span="5"><span :style="'color:'+GetDiveMainBack()">评语</span></van-col>
            <van-col span="19">
              <van-field v-model="progressForm.comment" style="padding:0" placeholder="请输入评语" type="textarea" rows="1" autosize maxlength="256" show-word-limit />
            </van-col>
          </van-row>
          <van-row gutter="10">
            <van-col span="12"><van-button :color="GetColorSecondary()" size="small" style="width:100%" :loading="buttonLoading" @click="onCleanProgress">清空进度</van-button></van-col>
            <van-col span="12"><van-button :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="onSaveProgress">保存进度</van-button></van-col>
          </van-row>
        </div>

      </van-tab>
      <van-tab title="日志" name="log">
        <div v-if="data" class="LogInfo LogPage">
          <div v-for="log in data.logList" :key="log.studentLogId" class="LogRect">
            <van-tag mark :color="GetDiveMainBack()">  {{ GetEnumText("Em_DiveStudentLogType",log.type ) }}</van-tag>
            <span class="data">{{ log.body }}</span>
            <span class="date">{{ formatDate(log.createTime,"yyyy-MM-dd hh:mm",true) }}</span>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <mgrVerifyCertificate v-model="showAddVerifyCertificate" @reload="init" />
    <diveCommentPopup v-model="selectCommentId" :comment-type="selectCommentType" />
    <mgrStudentStop v-model="selectStudentStopId" :title="selectStudentStopName" @reload="init" />
    <mgrStudentProgressEdit
      v-model="showStudentProgressEdit"
      :select-progress-info="selectProgressInfo"
      :student-progress-read-only="StudentProgressReadOnly"
      @reload="init()"
    />
    <mgrStudentProgressInfo v-model="showStudentProgressInfo" :select-progress-info="selectProgressInfo" />
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton, Step, Steps, Tab, Tabs, Tag, Image, Lazyload, Popup, Checkbox, Field, RadioGroup, Radio, Dialog, CountDown, ImagePreview } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, GetEnumList, ShowFloat, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetIsEnableInsurance, getUrlKey, GetDiveMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import mgrVerifyCertificate from '@/views/pro/trip/mgrVerifyCertificate'
import diveCommentPopup from '@/components/diveCommentPopup'
import mgrStudentStop from '@/views/pro/trip/mgrStudentStop'
import mgrStudentProgressEdit from '@/views/pro/trip/mgrStudentProgressEdit'
import mgrStudentProgressInfo from '@/views/pro/trip/mgrStudentProgressInfo'
import wxShare from '@/components/wxShare'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    [CountDown.name]: CountDown,
    [ImagePreview.name]: ImagePreview,
    TopBar,
    mgrVerifyCertificate,
    diveCommentPopup,
    mgrStudentStop,
    mgrStudentProgressEdit,
    mgrStudentProgressInfo,
    wxShare
  },
  data() {
    return {
      titleTop: '',
      title: '',
      backurl: '/store/index',
      loading: true,
      data: undefined,
      id: undefined,
      buttonLoading: false,
      activeManage: 'member',
      copyStr: undefined,
      activeMember: 0,
      TopBarY: 0,
      showStudentProgressInfo: false,
      selectProgressInfo: undefined,
      progressStateList: [],
      progressCompletionList: [],
      progressForm: {
        classId: undefined,
        isClean: false,
        completionState: 'Good',
        state: 'FINISH',
        comment: '',
        studentIds: [],
        unitIds: []
      },
      StudentProgressReadOnly: true,
      showStudentProgressEdit: false,
      showAddVerifyCertificate: undefined,
      selectCommentId: undefined,
      selectCommentType: undefined,
      selectStudentStopId: undefined,
      selectStudentStopName: undefined,
      system: '',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''

    }
  },

  created() {
    this.system = getUrlKey('system')
    this.titleTop = GetSysTitle()
    this.id = this.$route.params.id
    this.progressForm.classId = this.id
    this.init(() => {
      if (this.progressStateList.length <= 0) {
        this.progressStateList = GetEnumList('Em_DiveUnitState')
        this.progressCompletionList = GetEnumList('Em_CompletionState').filter(item => item.value !== 'UNFINISH' && item.value !== 'UNKNOW')
      }
    })
  },

  methods: {
    GetIsEnableInsurance,
    GetSelfUrl,
    MyNotify,
    ShowFloat,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      request({
        url: '/DiveTrip/getCoachDiveClass',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.loading = false
        var i = 0
        response.data.unitList.forEach(item => {
          if (this.data) {
            item.select = this.data.unitList[i].select
            i++
          } else {
            item.select = false
          }
        })
        i = 0
        response.data.memberList.forEach(item => {
          if (item.insurance && item.insurance.order) {
            item.insurance.orderInfo = JSON.parse(item.insurance.order.body)
            item.insurance.order.body = undefined
          }
          item.logList = response.data.logList.filter(m => m.studentId === item.student.studentId)
          if (this.data) {
            item.select = this.data.memberList[i].select
            i++
          } else {
            item.select = true
          }
        })
        this.data = response.data
        console.log('数据', this.data)
        this.title = this.data.team.className
        if (callback) {
          callback()
        }
      })
    },
    getStudentProgress(list, diveCourseUnitId) {
      if (list.length <= 0) {
        return null
      }
      var select = list.filter(item => item.diveCourseUnitId === diveCourseUnitId)
      if (select.length <= 0) {
        return null
      }
      return select[0]
    },
    getUnitStateColor(member, diveCourseUnitId) {
      var progress = this.getStudentProgress(member.progressList, diveCourseUnitId)
      // console.log(diveCourseUnitId, progress)
      if (!progress) {
        return '#ccc'
      }
      if (progress.state !== 'FINISH') {
        switch (progress.state) {
          case 'CANCEL' : return '#ee0a24'
          case 'UNFINISH' : return '#ff976a'
          case 'WAIT' : return '#999'
        }
      } else {
        switch (progress.completionState) {
          case 'UNFINISH' : return '#63FAAA'
          case 'Bad' : return '#0FF77D'
          case 'Normal' : return '#07c160'
          case 'Good' : return '#059C4D'
          case 'VeryGood' : return '#035A2D'
        }
      }
    },
    getUnitStateText(member, diveCourseUnitId) {
      var progress = this.getStudentProgress(member.progressList, diveCourseUnitId)
      if (!progress) {
        return '/'
      }
      if (progress.state !== 'FINISH') {
        switch (progress.state) {
          case 'CANCEL' : return 'x'
          case 'UNFINISH' : return '!'
          case 'WAIT' : return '-'
        }
      } else {
        switch (progress.completionState) {
          case 'UNFINISH' : return '0'
          case 'Bad' : return '1'
          case 'Normal' : return '2'
          case 'Good' : return '3'
          case 'VeryGood' : return '4'
        }
      }
    },
    onMemberScroll(data) {
      this.TopBarY = -((data.scrollTop - 44) / 44) * 3
    },
    onSelectProgress(member, unit, progress) {
      var id
      if (this.selectProgressInfo && this.selectProgressInfo.progress) {
        id = this.selectProgressInfo.progress.diveProgressId
      }
      this.showStudentProgressInfo = false
      this.selectProgressInfo = undefined
      if (!progress || id === progress.diveProgressId) {
        return
      }
      this.selectProgressInfo = {
        member: member.student,
        unit: unit,
        progress: progress
      }
      this.showStudentProgressInfo = true
    },

    toggleAll(list, isSelect) {
      console.log('onToggleAll', list)
      if (isSelect === undefined || isSelect === null) {
        list.forEach(item => {
          if (item.select === true) {
            item.select = false
          } else {
            item.select = true
          }
        })
      } else {
        list.forEach(item => {
          item.select = isSelect
        })
      }
    },
    setUpdateData(isClean) {
      this.progressForm.isClean = isClean
      this.progressForm.studentIds = []
      this.progressForm.unitIds = []
      this.data.memberList.forEach(item => {
        if (item.select) {
          this.progressForm.studentIds.push(item.student.studentId)
        }
      })
      this.data.unitList.forEach(item => {
        if (item.select) {
          this.progressForm.unitIds.push(item.diveCourseUnitId)
        }
      })
    },
    onSaveProgress() {
      this.setUpdateData(false)
      this.buttonLoading = true
      request({
        url: '/DiveTrip/updateDiveProgress',
        method: 'post',
        data: this.progressForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '保存进度成功', 2000)
        this.init()
      })
    },
    onCleanProgress() {
      Dialog.confirm({
        title: '清空进度',
        message: '是否要清空进度?一旦清空无法撤销!',
        cancelButtonText: '取消',
        confirmButtonText: '清空'
      }).then(() => {
        this.onCleanProgressDo()
      })
    },
    onCleanProgressDo() {
      this.setUpdateData(true)
      this.buttonLoading = true
      request({
        url: '/DiveTrip/updateDiveProgress',
        method: 'post',
        data: this.progressForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '清空进度成功', 2000)
        this.init()
      })
    },
    onShowProgressEdit(member, unit, progress) {
      this.StudentProgressReadOnly = member.student.state !== 'Wait' &&
         member.student.state !== 'OnTheoretical' &&
         member.student.state !== 'FinishTheoretical' &&
         member.student.state !== 'OnCourse'

      this.selectProgressInfo = {
        member: member.student,
        unit: unit,
        progress: progress
      }
      console.log('onShowProgressEdit', this.selectProgressInfo)

      if (progress) {
        this.progressForm.state = progress.state
        this.progressForm.completionState = progress.completionState
        this.progressForm.comment = progress.comment
      } else {
        this.progressForm.state = 'FINISH'
        this.progressForm.completionState = 'Good'
        this.progressForm.comment = ''
      }
      this.showStudentProgressEdit = true
    },
    // onProgressEditClose() {
    //   this.progressForm.state = 'FINISH'
    //   this.progressForm.completionState = 'Good'
    //   this.progressForm.comment = ''
    //   this.selectProgressInfo = undefined
    // },
    checkAllUnitFinish(member) {
      return member.progressList.filter(item => item.state !== 'FINISH').length <= 0 && member.progressList.length === this.data.unitList.length
    },
    onVerifyCertificate(member) {
      this.showAddVerifyCertificate = member
    },
    onFinishScheduling(member) {
      if (member.student.state === 'Certificate' || member.student.state === 'Success') {
        MyNotify('info', '行程已完成', 2000)
        return
      }
      this.buttonLoading = true
      request({
        url: '/DiveTrip/finishDiveScheduling',
        method: 'post',
        params: { id: member.student.studentId }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '行程已标记完成', 2000)
        this.init()
      })
    },
    onViewComment(type, commentId) {
      this.selectCommentType = type
      this.selectCommentId = commentId
    },
    onShareComment(student) {
      console.log('onShareComment', student)
      this.showShare = true
      var shareBody = ''
      if (this.data.course.tripType === 'COURSE') {
        shareBody = '恭喜' + student.loaclName + '完成' + this.data.diveStoreName + ' ' + this.data.course.name + '课程,请对我的教学质量进行评分!'
      } else {
        shareBody = this.data.diveStoreName + ' ' + this.data.course.name + '行程已结束,' + student.loaclName + '请对行程及我进行评分!'
      }
      this.shareTitle = shareBody
      this.shareAbout = shareBody
      this.shareTimeline = shareBody
      this.shareUrl = undefined
      this.shareUrl = GetSelfUrl() + 'divetrip/tripComment/' + student.studentId + '?system=' + this.system
      this.shareIcon = GetSelfUrl() + 'img/picShare.jpg'
    },
    onShareClass() {
      console.log('onShareClass')
      this.showShare = true
      var shareBody = ''
      if (this.data.course.tripType === 'COURSE') {
        shareBody = '恭喜完成' + this.data.diveStoreName + ' ' + this.data.course.name + '课程的潜水员,请对我的教学质量进行评分!'
      } else {
        shareBody = this.data.diveStoreName + ' ' + this.data.course.name + '行程已结束,请对行程及我进行评分!'
      }
      this.shareTitle = shareBody
      this.shareAbout = shareBody
      this.shareTimeline = shareBody
      this.shareUrl = undefined
      this.shareUrl = GetSelfUrl() + 'divetrip/tripComment/0?system=' + this.system + '&classid=' + this.data.team.diveClassId
      this.shareIcon = GetSelfUrl() + 'img/picShare.jpg'
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onStopStudent(student) {
      this.selectStudentStopName = '终止' + student.firstName + ' ' + student.lastName + '的行程'
      this.selectStudentStopId = student.studentId
    },
    onReStopStudent(student) {
      Dialog.confirm({
        title: '行程终止失败',
        message: '顾客已打回终止申请,是否要恢复申请前状态?(恢复后可重新申请终止)'
      })
        .then(() => {
          this.buttonLoading = true
          request({
            url: '/DiveTrip/StopDiveLearningCancel',
            method: 'post',
            params: { id: student.studentId }
          }).then(Response => {
            this.buttonLoading = false
            if (!Response.success) {
              return
            }
            MyNotify('success', '恢复状态成功!', 2000)
            this.init()
          })
        })
    },
    onShowDiveOrderInfo(diveOrderId) {
      this.$router.push('/pro/trip/diveOrder/' + diveOrderId)
    },
    onCopySocialMediaAccount(e) {
      MyNotify('success', '已复制:' + e.text, 2000)
    },
    onImagePreview(url) {
      ImagePreview([url])
    }
  }
}
</script>

<style scoped>
.baseRect{
  padding: 0.5em 1em;
  margin-bottom: 0.5em;
  background-color: #fff;
}
.baseRect .values{
  font-size: 0.8em;
  padding: 0.25em 0;
}
.baseRect .topTitle{
  font-size: 0.9em;
  padding: 0.25em 0;
  font-weight: 700;
}
.baseRect .topTitle span{
  margin-left: 0.5em;
}
 .tableRect{
  width: 100%;
  font-size: 0.8em;
}
 .tableRect td{
  border:1px solid #fafafa;
  padding: 0.25em;
}

 .tableRect .title{
  text-align: center;
}

.memberRect .HeadRect{
  position: relative;
}
.memberRect .HeadRect .head{
  position: absolute;
  left: 0em;
  top: 0em;
}
.memberRect .HeadRect .valueRect{
  padding-left: 5.5em;
  min-height: 6.5em;
}
.memberRect .unitRect
{

}
.progressRect
{
  background-color: #fff;
    overflow-y:scroll;
    margin-bottom: 0.5em;
}
.progressRect::-webkit-scrollbar {
    height: 5px;
}
.progressRect::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #999;
    text-align: right;
}
.progressRect .rect{
  color:#fff;
  width: 1.2em;
  text-align: center;
}

.LogInfo{
  margin-top: 0.5em;
}
.LogInfo .LogRect{
    margin-bottom: 0.25em;
    padding-bottom: 0.25em;
    border-bottom: 1px solid #f5f5f5;
}
.LogInfo .LogRect:last-child{
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
}
.LogInfo .LogRect .data{
    font-size: 0.8em;
    margin-left: 0.5em;
}
.LogInfo .LogRect .date{
    font-size: 0.8em;
    color: #999;
    margin-left: 0.5em;
}
.LogPage{
  background-color: #fff;
  margin-top: 0 !important;
  padding: 0.5em 1em;
}
.radioItem{
  margin-bottom: 0.5em;
}
</style>
